import { supabase } from "@/integrations/supabase/client";

// Input sanitization utility
export const sanitizeInput = (input: string): string => {
  return input
    .trim()
    .replace(/[<>]/g, '') // Remove potential XSS characters
    .slice(0, 1000); // Limit length
};

// Secure form submission utility using backend function
export const submitToCustomerIO = async (data: {
  email: string;
  name?: string;
  company?: string;
  message?: string;
  firstName?: string;
  lastName?: string;
  deploymentRegion?: string;
}, formSlug?: string) => {
  try {
    // Sanitize all inputs
    const sanitizedData = Object.entries(data).reduce((acc, [key, value]) => {
      if (value && typeof value === 'string') {
        acc[key] = sanitizeInput(value);
      }
      return acc;
    }, {} as Record<string, string>);
    
    const { data: responseData, error } = await supabase.functions.invoke('submit-demo-request', {
      body: {
        ...sanitizedData,
        formSlug: formSlug || 'demo-request'
      },
    });

    if (error) {
      console.error('Form submission error:', error);
      throw new Error('Unable to submit request. Please try again later.');
    }

    return { success: true };
  } catch (error) {
    console.error('Form submission error:', error);
    throw new Error('Unable to submit request. Please try again later.');
  }
};
